import Swiper from 'swiper/bundle';

export default class Bnr {
    constructor() {
        this.init();
    }

    init() {
        this.setSwiper();
    }

    setSwiper() {
        const option = {
            autoplay: { delay: 5000 },
            loop: true,
            pagination: { el: '.swiper-pagination', clickable: true, },
            
        };

        const swiper = new Swiper('.bnr__cont', option);
    }
}
